import { useConfigMutation } from "@hooks";

import * as Apis from "../api";

const useAccountingMutation = (() => {
  return useConfigMutation({ apis: Apis });
})();

export default useAccountingMutation;
